import LayoutSalesChallengeRegister from './LayoutSalesChallengeRegister';
export default LayoutSalesChallengeRegister;
